<template>
  <section class="!h-dvh !w-dvw !bg-[#EFFAF8]">
    <div
      v-loading="loading"
      element-loading-text="Submitting the form, please wait..."
      element-loading-spinner="el-icon-loading"
    >
      <div class="text-center flex items-center justify-center h-dvh">
        <div
          class="success-card rounded-2xl overflow-hidden xl:!w-[45%] mx-auto p-5 bg-white shadow-md"
        >
          <div class="w-fit h-fit p-2 bg-[#219653] rounded-full mx-auto">
            <img src="@/assets/img/icons/new/whiteTick-icon.svg" alt="icon" class="!size-12" />
          </div>
          <p v-if="isEdited" class="success-head-text !text-2xl !text-black">Updated Successful</p>
          <p v-else class="success-head-text m-1 !text-2xl !text-black-950 pt-1">
            Submission Successful
          </p>
          <p
            class="success-sub-head"
            style="text-align: center"
            v-if="getUserMessage"
            v-html="finalThankyouText"
          ></p>
          <p class="success-sub-head" v-else>Thanks! We have received your submission.</p>
          <div
            class="success-actions border-b border-black/10 pb-4 mb-4"
            v-if="this.$route.name !== 'ApplicaionFormbuilderCompleted'"
          >
            <button
              type="text"
              @click="showMySubmissions"
              v-if="checkIsVisable && this.getFormBuilder.settings.edit_responses"
            >
              <div
                class="flex items-center !gap-2 bg-[#2F80ED1A] rounded-md overflow-hidden !px-3 !py-1.5"
              >
                <span><img src="@/assets/img/icons/new/pencil-icon.svg" alt="" /></span>
                <span>Edit my recent submission</span>
              </div>
            </button>
            <button class="!ml-4" type="text" @click="showMyAllSubmissions" v-if="checkIsVisable">
              <div
                class="flex items-center !gap-2 bg-[#6D59D41A] rounded-md overflow-hidden !px-3 !py-1.5"
              >
                <span>
                  <img class="" src="@/assets/img/icons/new/pinkdocument-icon.svg" alt="" />
                </span>
                <span>Show my submissions</span>
              </div>
            </button>
          </div>
          <div class="suggest-box flex flex-col items-center">
            <div
              class="flex items-center !gap-2 bg-[#EB57571A] rounded-md overflow-hidden !px-3 !py-1.5 !mb-4"
            >
              <span>
                <img src="@/assets/img/icons/new/upgrade-icon.svg" alt="" />
              </span>
              <span class="text-amber-500">Upgrade Your Workflow</span>
            </div>
            <div class="suggest-card" v-if="this.$route.name === 'ApplicaionFormbuilderCompleted'">
              <el-button @click="goBack">Go back</el-button>
              <el-button type="danger" @click="gotoDashboard">Go to dashboard</el-button>
            </div>
            <div
              class="suggest-card"
              v-else-if="this.$route.name === 'CompanyUserFormbuilderCompleted'"
            >
              <el-button @click="goBack">Go back</el-button>
              <el-button type="danger" @click="gotoDashboard">Go to dashboard</el-button>
            </div>
            <div v-else class="suggest-card">
              <div v-if="this.getFormBuilder.customization.show_try_esigns_and_content">
                <p class="suggest-head">Get started with {{ appName }}</p>
                <p class="suggest-text">
                  Discover the most hassle-free experience of data management and custom forms. Get
                  started with {{ appName }} to unleash the great potential of automation workflows.
                </p>
                <button
                  class="!bg-brand-500 px-3 py-1.5 !rounded-md text-white"
                  @click="gotoSignIn"
                >
                  Try {{ appName }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import { mapGetters } from 'vuex';
  import config from '@/config/app';
  import { postAPICall } from '../../helpers/httpHelper';
  import app from '../../config/app';
  export default {
    data() {
      return {
        appName: app.appName,
        loading: false,
        step: 1,
        slug: null,
        layout: 'div',
        employeeData: {},
        stepTypeMap: {
          COMPANY_BENEFIT: 'Company Benefits',
          COMPANY_DOCUMENTS: 'Company Documents',
          OFFER_LETTER: 'Offer Letter',
          RELATIONAL_DATA: 'Relational Data',
        },
        workflowCode: null,
        workflowDataId: null,
        userWorkflowStepsData: [],
        centerDialogVisible: true,
        thankyou_page: 'You are completed Form builder by filling all details',
        isEdited: false,
        finalThankyouText: '',
      };
    },
    computed: {
      ...mapGetters('formbuilderData', [
        'getFormbuilderDataCreateByTemplateStatus',
        'getNewFormbuilderData',
        'getNewFormbuilderDataError',
      ]),
      ...mapGetters('formBuilders', ['getFormBuilderAddStatus', 'getFormBuilder']),
      ...mapGetters('company', [
        'getCompanyDetails',
        'getUpdateCompany',
        'getCompanyLogo',
        'getSingleCompanyLogo',
      ]),
      ...mapGetters('auth', ['getAuthenticatedUser']),
      ...mapGetters('navigationOpen', ['getIsMobile']),
      getAllSteps() {
        return this.getFormBuilder.steps;
      },
      checkIsVisable() {
        return (
          this.getFormBuilder &&
          this.getFormBuilder.settings &&
          this.getFormBuilder.settings.view_responses
        );
      },
      getUserMessage() {
        return (
          this.getFormBuilder &&
          this.getFormBuilder.settings &&
          this.getFormBuilder.settings.success_and_redirect_page &&
          !this.getFormBuilder.settings.success_and_redirect_page.redirect_to &&
          this.getFormBuilder.settings.success_and_redirect_page.thankyou_page
        );
      },
      getCompanyLogo() {
        if (this.getSingleCompanyLogo) {
          return `${config.S3_BUCKET_URL}/${this.getSingleCompanyLogo}`;
        } else {
          return null;
        }
      },
    },
    async mounted() {
      if (
        this.$route &&
        this.$route.query &&
        this.$route.query.type &&
        this.$route.query.type == 'edit'
      ) {
        this.isEdited = true;
      }
      await this.getThankyouText();
    },
    methods: {
      async getThankyouText() {
        try {
          if (this.getFormBuilder?.settings?.success_and_redirect_page?.thankyou_page) {
            this.loading = true;
            let params = {
              formbuilder_data_id: this.getNewFormbuilderData._id,
            };
            let responseData = await postAPICall(
              'GET',
              `/formbuilder-data/${this.getNewFormbuilderData._id}`,
              params
            );
            this.finalThankyouText = responseData?.data?.thank_you_text
              ? responseData.data.thank_you_text
              : `Thank you for submitting the ${this.getFormBuilder.name} form`;
            this.loading = false;
          } else {
            this.finalThankyouText =
              'Thank you for submitting the ' +
              (this.getFormBuilder?.name ? this.getFormBuilder.name : '') +
              ' form';
          }
          this.$nextTick(() => {
            this.resetStylesForInjectedContent();
          });
        } catch (err) {
          console.log('errrr', err);
        }
      },

      resetStylesForInjectedContent() {
        const ulElements = document.querySelectorAll('.success-sub-head ul');
        const liElements = document.querySelectorAll('.success-sub-head li');

        ulElements.forEach((ul) => {
          ul.style.margin = '10px 0';
          ul.style.paddingLeft = '20px';
          ul.style.textAlign = 'left';
        });

        liElements.forEach((li) => {
          li.style.listStyleType = 'disc';
          li.style.listStylePosition = 'inside';
        });
      },
      neverClose() {
        this.centerDialogVisible = true;
      },
      goBack() {
        if (this.$route.name == 'CompanyUserFormbuilderCompleted') {
          this.$router.push(`/fbd/${this.getFormBuilder.code}`);
        } else if (window.opener) {
          window.close();
        } else {
          this.$router.push('/ap/dashboard');
        }
      },
      gotoDashboard() {
        if (this.$route.name === 'ApplicaionFormbuilderCompleted') {
          this.$router.push({
            path: '/ap/dashboard',
          });
        } else {
          this.$router.push({
            path: '/dashboard',
          });
        }
      },
      gotoSignIn() {
        this.$router.push({
          path: '/signup',
        });
      },
      showMyAllSubmissions() {
        this.$router.push({
          name: 'GuestFormbuilderUserSubmittedDataList',
          params: {
            formbuilder_code: this.$route.params.formbuilder_code,
            formbuilder_details_id: this.$route.params.formbuilder_details_id,
            user_id: this.getAuthenticatedUser._id,
          },
        });
      },
      showMySubmissions() {
        this.hasEditMsg = 1;
        if (this.getNewFormbuilderData) {
          this.$router.push({
            name: 'GuestFormbuilderExecute',
            params: {
              formbuilder_details_id: this.$route.params.formbuilder_details_id,
            },
            query: {
              formbuilder_data_id: this.getNewFormbuilderData._id,
              stepId: 0,
              type: 'edit',
            },
          });
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .success-body {
    background: #effaf8 !important;
    // margin-top: 25px;
    text-align: center !important;
    display: flex;
    align-items: center;
    justify-content: center;

    .success-card {
      width: fit-content;
      height: 100%;
      border: 1px solid rgba(203, 214, 226, 0.5);

      @media (min-width: 749px) {
        width: 749px;
        min-height: 260px;
      }

      .success-logo {
        width: 80px;
      }

      .success-head-text {
        font-weight: 500;
        font-size: 26px;
        color: #212529;
      }

      .success-sub-head {
        color: #303133;
        font-weight: 400;
        font-size: 16px;
      }

      .success-actions {
        display: inline !important;
      }
    }
  }

  .suggest-box {
    margin-top: 20px;
    text-align: center !important;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (min-width: 749px) {
      margin-top: 5px;
    }

    .suggest-card {
      width: 100%;

      @media (min-width: 749px) {
        width: 650px;
      }

      .suggest-head {
        color: #212529;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
      }

      .suggest-text {
        font-weight: 400;
        font-size: 14px;
      }
    }
  }
</style>
